/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

( ( document ) => {
	const btn = document.querySelector( '.h-js-header__drawer-toggle-link' );
	const drawer = document.querySelector( '.h-c-header__drawer' );
	if ( !btn || !drawer ) {
		return;
	}

	btn.addEventListener( 'click', () => {
		document.body.classList.add( 'h-is-showing-drawer' );
		drawer.classList.add( 'h-is-visible' );
	} );

	const backdrop = document.getElementById( 'h-js-header__drawer-backdrop' );
	if ( backdrop ) {
		backdrop.addEventListener( 'click', () => {
			document.body.classList.remove( 'h-is-showing-drawer' );
			drawer.classList.remove( 'h-is-visible' );
		} );
	}
} )( document );
